var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-primary logo"},[_c('b-img',{attrs:{"src":require('@/assets/logo/logo.png'),"alt":"logo","height":"35"}}),_vm._v(" Vatika ERP ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }